/* One list of what goes with what, shared by the Added to cart popup (assets/cozyleigh-added-pairs.js) and the cart
   suggestions (snippets/cl-cart-recs). Built from what shoppers actually buy together.
   - Pieces: each has a full-price product and, for some, an Imperfectly Perfect one. A cart with any Imperfectly
     Perfect piece is offered the Imperfectly Perfect version of a piece where there is one (the puck has none).
   - Colours: a suggestion starts on the colour already chosen, else the same family (Dusty Blush stand -> Blush mat).
   - Wood: the wooden pieces suggest each other the way they're bought together (Zen Tray + Book Stand, Desk Shelf +
     Zen Tray), matched on wood.
   - Reasons: each suggestion carries one short line saying why it belongs with what's in the cart (reason()). Facts
     only: every stand already includes a puck; the stand, puck and Fa tray snap onto the Pro mat and the Zen Tray. */
(function () {
  if (window.CozyleighPairs) return;

  var PIECES = {
    stand: { full: 'zen-magsafe-charger-stand-1', ip: 'zen-magsafe-charger-stand-imperfectly-perfect' },
    puck: { full: 'zen-magsafe-charger-puck' },
    fa: { full: 'fa-trinket-tray', ip: 'fa-stackable-trinket-tray-save-20-off' },
    mat: { full: 'cozyleigh-deskmat', ip: 'cozyleigh-desk-mat-b-stock' }
  };
  // wood pieces sit on the desk with the others but aren't magnetic companions themselves
  var WOOD = ['zen-tray', 'zen-desk-shelf', 'zen-book-stand'];
  // what each wooden piece suggests, in order (a piece key from PIECES, or another wooden piece's handle)
  var WOOD_PAIRS = {
    'zen-tray': ['fa', 'zen-book-stand', 'stand'],
    'zen-book-stand': ['zen-tray', 'zen-desk-shelf', 'fa'],
    'zen-desk-shelf': ['zen-tray', 'zen-book-stand', 'fa']
  };
  // keycaps go with the novelty kit (and artisan) of the same profile
  var KEYCAPS = {
    'zen-keycaps': ['zen-novelty-kit'],
    'zen-novelty-kit': ['zen-keycaps'],
    'zen-marshmallow-keycaps': ['zen-marshmallow-novelty-kit', 'zen-marshmallow-metal-artisan'],
    'zen-marshmallow-novelty-kit': ['zen-marshmallow-keycaps', 'zen-marshmallow-metal-artisan'],
    'zen-marshmallow-metal-artisan': ['zen-marshmallow-keycaps', 'zen-marshmallow-novelty-kit']
  };
  var FAMILIES = [
    ['blush', 'dusty blush', 'rose', 'peach', 'terracotta', 'dusty terracotta', 'dusty plum'],
    ['matcha', 'pistachio', 'sage', 'mint', 'ginkgo', 'gingko', 'olive', 'teal'],
    ['beige', 'white', 'stone', 'frost', 'sky', 'lavender', 'lemon', 'yuzu', 'galaxy', 'charcoal'],
    ['latte', 'caramel', 'walnut', 'chocolate']
  ];

  // {key: 'stand', ip: false} for a piece's handle, or null
  function pieceOf(handle) {
    for (var k in PIECES) {
      if (PIECES[k].full === handle) return { key: k, ip: false };
      if (PIECES[k].ip && PIECES[k].ip === handle) return { key: k, ip: true };
    }
    return null;
  }
  // the handle to offer for a piece: the Imperfectly Perfect one in that lane when there is one
  function handleFor(key, ip) { var p = PIECES[key]; return p ? (ip && p.ip) || p.full : null; }
  function isSecondChoice(p) {
    var h = p && p.handle || '';
    var pc = pieceOf(h);
    return pc ? pc.ip : /imperfectly perfect/i.test(p && p.title || '') || /imperfectly-perfect|b-stock|save-\d+-off/.test(h);
  }
  function family(colour) {
    var c = String(colour || '').toLowerCase();
    for (var i = 0; i < FAMILIES.length; i++) if (FAMILIES[i].indexOf(c) > -1) return i;
    return -1;
  }
  function optionValues(v) {
    if (v.options && v.options.length) return v.options.map(String);
    return [v.option1, v.option2, v.option3].filter(function (o) { return o != null; }).map(String);
  }
  // how well a variant matches: the Pro mat first (it's what holds the pieces in place), then exact colour 4, same family 2
  function colourScore(v, colours) {
    var fams = colours.map(family).filter(function (f) { return f > -1; });
    return optionValues(v).reduce(function (s, o) {
      if (colours.indexOf(o) > -1) return s + 4;
      if (fams.indexOf(family(o)) > -1) return s + 2;
      return o === 'Pro' ? s + 8 : s;
    }, 0);
  }
  // the best in-stock variant for those colours (null when nothing is in stock)
  function bestVariant(variants, colours) {
    return (variants || []).filter(function (v) { return v.available; })
      .reduce(function (best, v) { return !best || colourScore(v, colours) > colourScore(best, colours) ? v : best; }, null);
  }

  // why a suggestion belongs, in one short line. what: a piece key ('fa', 'mat', 'puck', 'stand'), 'stack' (another
  // Fa tray) or a wooden piece's handle. ctx.stand: a stand is in the cart, was just added, or the customer owns one;
  // ctx.pieces === false: nothing in the cart (or owned) snaps onto a mat, so the mat isn't sold on that.
  function reason(what, ctx) {
    var stand = !!(ctx && ctx.stand);
    switch (what) {
      case 'fa': return stand ? 'For the little things that land beside your stand' : 'A little tray for your everyday things';
      case 'stack': return 'They stack: mix colours, one lid on top';
      case 'mat': return stand ? 'Your stand snaps onto Pro and stays put' : ctx && ctx.pieces === false ? 'Two sides: linoleum and merino wool' : 'Your pieces snap onto Pro and stay put';
      case 'puck': return stand ? 'A second one, for your AirPods' : 'A resting spot for AirPods, or to charge lying flat';
      case 'stand': return 'Our most-loved piece';
      case 'zen-tray': return 'A wooden base your pieces stay put on';
      case 'zen-book-stand': return 'For the book you’re reading now';
      case 'zen-desk-shelf': return 'Lifts your screen, keeps things close';
    }
    return '';
  }
  // the index of a product's size option when there's a real choice of sizes, else -1 (product .js or cart JSON)
  function sizeIndex(product) {
    var opts = product && product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i], name = typeof o === 'string' ? o : o && o.name;
      if (/size/i.test(name || '') && (typeof o === 'string' || (o.values || []).length > 1)) return i;
    }
    return -1;
  }
  // "Medium (32"x15")" -> "Medium" for a small chip
  function shortSize(v) { return String(v).replace(/\s*\(.*\)\s*$/, ''); }

  // The photo a recommendation shows for a variant (product and variant from /products/<handle>.js). A lidded piece
  // (the Fa tray: media alt "Fa tray stack (top to bottom): Rose") shows its lid-on twin ("Fa tray stack with lid (top
  // to bottom): Rose"), the same photo the starter sets use (snippets/cozyleigh-set-cut) and the product page's "Lid on"
  // view, because every tray comes with its lid; anything else, or a tray with no twin, shows the variant's own photo.
  function offerImage(product, variant) {
    var own = variant && (variant.featured_image && variant.featured_image.src || (typeof variant.featured_image === 'string' ? variant.featured_image : '')) || product && product.featured_image || '';
    var alt = variant && variant.featured_media && variant.featured_media.alt || '';
    if (alt.indexOf('stack (') > -1) {
      var want = alt.replace('stack (', 'stack with lid (');
      var media = product && product.media || [];
      for (var i = 0; i < media.length; i++) {
        var m = media[i];
        if (m && m.alt === want && m.media_type === 'image') return m.src || m.preview_image && m.preview_image.src || own;
      }
    }
    return own;
  }

  // US shipping (Theme settings -> "Cozyleigh US shipping"; snippets/cl-ship-line, snippets/cl-ship-class and
  // snippets/cl-cart-recs). Which line and price a piece counts toward: 'box' (stand, puck, Fa tray, and their
  // Imperfectly Perfect versions: the printed pieces, the $75 line, $6), 'small' (Zen Book Stand: wood, ships in the
  // same box for $6, but counts toward the everyday $150 line), 'tray' (Zen Tray: the high line, said only on its own page),
  // 'shelf' (Zen Desk Shelf: rate worked out at checkout, never priced here), 'none' (doesn't ship) or 'other' (the everyday line).
  // Product tags first (stand-box, small-box, zen-tray, set in Shopify), then these handles and names. The Desk Shelf
  // wins over any tag. Pieces on their own Shopify shipping profile count as 'none' too, because the shipping app never
  // sees them: the Zen Lights (Gantri, always free), Collective pieces (osume) and MySweetChubs prints and stickers.
  // snippets/cl-ship-class is the same rules in Liquid; keep the two in step.
  var SHIP_BOX = [PIECES.stand.full, PIECES.stand.ip, PIECES.puck.full, PIECES.fa.full, PIECES.fa.ip];
  var SHIP_APART = ['gantri', 'osume'];
  function shipClass(handle, title, tags, requiresShipping, vendor) {
    if (requiresShipping === false) return 'none';
    var h = String(handle || ''), t = String(title || '');
    if (SHIP_APART.indexOf(String(vendor || '').trim().toLowerCase()) > -1 || /^mysweetchubs/i.test(t)) return 'none';
    tags = typeof tags === 'string' ? tags.split(',') : tags || [];
    tags = tags.map(function (x) { return String(x).trim().toLowerCase(); });
    if (h === 'zen-desk-shelf' || /desk shelf/i.test(t)) return 'shelf';
    if (tags.indexOf('zen-tray') > -1) return 'tray';
    if (tags.indexOf('stand-box') > -1) return 'box';
    if (tags.indexOf('small-box') > -1) return 'small';
    if (h === 'zen-tray' || /zen tray/i.test(t)) return 'tray';
    if (SHIP_BOX.indexOf(h) > -1 || /charger stand|charger puck|trinket tray/i.test(t)) return 'box';
    if (h === 'zen-book-stand' || /book stand/i.test(t)) return 'small';
    return 'other';
  }
  // the free-shipping line (in cents) for a cart holding pieces of these classes, or null when it never ships free
  // (a Desk Shelf) or nothing in it ships. lines: { box, all, tray } in cents.
  function freeShipLine(classes, lines) {
    var ship = (classes || []).filter(function (c) { return c !== 'none'; });
    if (!ship.length || ship.indexOf('shelf') > -1) return null;
    if (ship.indexOf('tray') > -1) return lines.tray;
    return ship.every(function (c) { return c === 'box'; }) ? lines.box : lines.all;
  }
  // a Pro desk mat (the Pro surface is its own, pricier box): the desk mat or its Imperfectly Perfect version, Pro chosen
  function isProMat(handle, variantTitle) {
    var pc = pieceOf(handle);
    return !!pc && pc.key === 'mat' && String(variantTitle || '').split(' / ').indexOf('Pro') > -1;
  }
  // a cart's shipping lines -> what the price rules need: [{ cls, cents, pro }]. items: cart.js items (or the same
  // fields): handle, product_title, vendor, variant_title, requires_shipping, original_line_price, product_id.
  // tags: { product_id: 'stand-box' | 'small-box' | 'zen-tray' } from Liquid (cart.js has no tags).
  function shipItems(items, tags) {
    return (items || []).map(function (it) {
      var tag = tags && tags[String(it.product_id)];
      return {
        cls: shipClass(it.handle, it.product_title, tag ? [tag] : [], it.requires_shipping, it.vendor),
        cents: +it.original_line_price || 0,
        pro: isProMat(it.handle, it.variant_title)
      };
    });
  }
  // The US (lower 48) price, the same rules the shipping app charges. Totals are items before discounts, in cents;
  // first match wins: Desk Shelf -> null (say nothing); Zen Tray -> free from lines.tray, else rates.tray; only printed
  // pieces -> free from lines.box, else rates.box; free from lines.all; only printed pieces and Book Stands ->
  // rates.box; a Pro desk mat -> rates.pro; else rates.other. null too when nothing in the cart ships.
  // rows: from shipItems(). lines: { box, all, tray }; rates: { box, other, tray, pro }, all cents.
  // Returns { free, rate (cents, 0 when free), line (the free-shipping line), subtotal }.
  function shipRate(rows, lines, rates) {
    var ship = (rows || []).filter(function (r) { return r.cls !== 'none'; });
    var classes = ship.map(function (r) { return r.cls; });
    var line = freeShipLine(classes, lines);
    if (line == null) return null;
    var subtotal = ship.reduce(function (s, r) { return s + (+r.cents || 0); }, 0);
    var out = function (rate) { return { free: rate === 0, rate: rate, line: line, subtotal: subtotal }; };
    if (subtotal >= line) return out(0);
    if (classes.indexOf('tray') > -1) return out(rates.tray);
    if (classes.every(function (c) { return c === 'box' || c === 'small'; })) return out(rates.box);
    if (ship.some(function (r) { return r.pro; })) return out(rates.pro);
    return out(rates.other);
  }

  // A free-shipping meter in the design kit's look (styles .cl-shipmeter in assets/cozyleigh.css), used by the setup
  // builder (sections/build-ecosystem), the top of the cart (snippets/cl-cart-recs) and the Added to cart popup
  // (assets/cozyleigh-added-pairs.js). The points goal card's bar a size smaller; a little parcel rides the end of the
  // green fill toward the end of the bar, and the moment the order crosses the line it lands on a tick with the kit's
  // pop and a few petals. The amount left sits on a strip of tape, like the site's headline highlights.
  // r: { free, subtotal, line } (shipRate() or the same fields), or null to hide it. One bar toward the line this order
  // is on, never $75 and $150 ticks together: which line applies depends on what's in the order. lines: { box, all,
  // tray } in cents, to name the line. opts: head (say "Add $N and it ships free"), freeText (once free, default "Free
  // US shipping on this order"), note (a second small line), link ({ text, href }: a quiet link under it), card (on a
  // taped paper note: the builder and the cart).
  function usd(cents) {
    var whole = cents % 100 === 0;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100); }
    catch (e) { return '$' + (whole ? cents / 100 : (cents / 100).toFixed(2)); }
  }
  // a kraft Cozyleigh box wrapped in our packaging tape (the peach, coral and matcha gradient printed on the real tape)
  var PARCEL = '<svg viewBox="0 0 20 20" width="22" height="22" aria-hidden="true" focusable="false"><path d="M3 6.5 10 9.5v7.5L3 14z" fill="#D9B285"/><path d="M10 9.5 17 6.5V14l-7 3z" fill="#C99D6E"/><path d="M3 6.5 10 3.5l7 3-7 3z" fill="#E8CBA2"/><path d="M5.21 5.55 7.79 4.45l7 3-2.58 1.1z" fill="#F2A07F"/><path d="M12.21 8.55 14.79 7.45v3.6l-2.58 1.1z" fill="#E9806B"/><path d="M12.21 12.15 14.79 11.05v3.9l-2.58 1.1z" fill="#A9B86A"/><path d="M3 6.5 10 3.5l7 3V14l-7 3-7-3zM3 6.5l7 3 7-3M10 9.5V17" fill="none" stroke="currentColor" stroke-width=".95" stroke-linejoin="round"/></svg>';
  var TICK = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PETALS = ['#F59178', '#FBB393', '#AEB263', '#FEDBAE', '#F0BCB0', '#C9D49E'];
  function burst(node) {
    var b = node.querySelector('.cl-shipmeter__burst'); if (!b) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    b.textContent = '';
    for (var i = 0; i < 10; i++) {
      var p = document.createElement('i'), a = (i / 10) * Math.PI * 2 + Math.random() * .5, d = 26 + Math.random() * 22;
      p.style.setProperty('--x', Math.round(Math.cos(a) * d) + 'px'); p.style.setProperty('--y', Math.round(Math.sin(a) * d - 8) + 'px');
      p.style.background = PETALS[i % PETALS.length]; p.style.animationDelay = (i % 3) * 40 + 'ms';
      b.appendChild(p);
    }
    setTimeout(function () { b.textContent = ''; }, 1600);
  }
  function paintShipMeter(node, r, lines, opts) {
    if (!node) return;
    if (!r) { node.hidden = true; node.__clFree = null; return; }
    opts = opts || {};
    var first = !node.__clMeter;
    if (!node.__clMeter) {
      node.__clMeter = true;
      node.classList.add('cl-shipmeter');
      node.innerHTML = '<p class="cl-shipmeter__head"></p>' +
        '<div class="cl-shipmeter__bar" aria-hidden="true"><span class="cl-shipmeter__track"><span class="cl-shipmeter__fill"></span></span>' +
        '<span class="cl-shipmeter__end"></span><span class="cl-shipmeter__rider"><span class="cl-shipmeter__parcel"></span><span class="cl-shipmeter__burst"></span></span></div>' +
        '<p class="cl-shipmeter__sub"></p><p class="cl-shipmeter__note"></p><a class="cl-shipmeter__link"></a>';
    }
    node.classList.toggle('cl-shipmeter--card', !!opts.card);
    var head = node.querySelector('.cl-shipmeter__head'), sub = node.querySelector('.cl-shipmeter__sub'), note = node.querySelector('.cl-shipmeter__note'), link = node.querySelector('.cl-shipmeter__link');
    var free = !!r.free, pct = free ? 100 : Math.max(6, Math.min(100, Math.round(r.subtotal / r.line * 100)));
    // first paint: the note eases in, the bar fills from empty and the parcel rides to its place (or onto the tick);
    // later paints (and reduced motion) just move to the new amount
    node.__clPct = pct + '%';
    if (first && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      node.__clEntering = true;
      node.style.setProperty('--cl-ship-pct', '0%');
      node.classList.add('is-enter');
      requestAnimationFrame(function () { requestAnimationFrame(function () { node.style.setProperty('--cl-ship-pct', node.__clPct); }); });
      setTimeout(function () {
        node.__clEntering = false; node.classList.remove('is-enter'); node.classList.toggle('is-free', !!node.__clFree);
        if (node.__clFree) { node.classList.add('is-pop'); setTimeout(function () { node.classList.remove('is-pop'); }, 900); }
      }, 1600);
    }
    if (!node.__clEntering) node.style.setProperty('--cl-ship-pct', node.__clPct);
    var parcel = node.querySelector('.cl-shipmeter__parcel');
    if (node.__clFree !== free) parcel.innerHTML = free ? TICK : PARCEL;
    // the moment it crosses the line (not on first paint): the parcel lands, a pop and a few petals
    if (node.__clFree === false && free) {
      node.classList.remove('is-pop'); void node.offsetWidth; node.classList.add('is-pop');
      burst(node);
      setTimeout(function () { node.classList.remove('is-pop'); }, 900);
    }
    node.__clFree = free;
    if (!node.__clEntering) node.classList.toggle('is-free', free);
    head.hidden = !opts.head;
    if (opts.head) head.innerHTML = free ? (opts.freeText || 'Free US shipping on this order') : 'Add <span class="cl-shipmeter__amt">' + usd(r.line - r.subtotal) + '</span> and it ships free';
    var which = r.line === lines.box ? ' on Zen MagSafe Charger Stands, Zen MagSafe Charger Pucks & Fa Trinket Trays' : r.line === lines.tray ? ' with a Zen Tray' : '';
    sub.textContent = free ? 'Lower 48 states only' : usd(r.subtotal) + ' of ' + usd(r.line) + which;
    note.textContent = opts.note || '';
    note.hidden = !opts.note;
    link.hidden = !(opts.link && !free);
    if (opts.link) { link.textContent = opts.link.text; link.href = opts.link.href; }
    node.hidden = false;
  }

  window.CozyleighPairs = {
    PIECES: PIECES, WOOD: WOOD, WOOD_PAIRS: WOOD_PAIRS, KEYCAPS: KEYCAPS,
    pieceOf: pieceOf, handleFor: handleFor, isSecondChoice: isSecondChoice,
    family: family, colourScore: colourScore, bestVariant: bestVariant,
    optionValues: optionValues, reason: reason, sizeIndex: sizeIndex, shortSize: shortSize, offerImage: offerImage,
    shipClass: shipClass, freeShipLine: freeShipLine, isProMat: isProMat, shipItems: shipItems, shipRate: shipRate,
    paintShipMeter: paintShipMeter
  };
})();
